"use client";

import React from "react";
import { Search, ShieldCheck, Users } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "01. Schedule",
  description: "Arrange your professional inspection through our simplified online portal. Select your preferred date and we will follow up to confirm availability and provide any preparation details.",
  icon: Search
}, {
  title: "02. Evaluate",
  description: "Our licensed home inspectors perform a detailed visual inspection of accessible major systems and components. Thermal imaging and moisture meters may be used as supplemental tools when conditions warrant.",
  icon: ShieldCheck
}, {
  title: "03. Resolve",
  description: "Receive a detailed digital report following completion of the inspection. We include high-resolution photography, repair prioritizations, and a direct consultation to discuss the report findings.",
  icon: Users
}];
export default function HowItWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="5191" id="inspection-process" ref={ref} className="bg-background py-[120px] relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="space-y-12 relative">
          {steps.map((step, index) => {
          const isLast = index === steps.length - 1;
          return <div key={index} data-index={index} className={cn("flex gap-6 md:gap-10 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
            transitionDelay: `${index * 200}ms`
          }}>
                {/* Step Indicator */}
                <div className="flex flex-col items-center relative shrink-0">
                  {/* Icon Circle */}
                  <div className="z-10 flex items-center justify-center w-12 h-12 rounded-full bg-secondary text-primary shadow-lg ring-4 ring-background">
                    <step.icon className="w-5 h-5" strokeWidth={2.5} />
                  </div>
                  
                  {/* Connector Line */}
                  {!isLast && <div className="absolute top-12 bottom-[-48px] w-0.5 bg-muted" />}
                </div>

                {/* Content */}
                <div className="pb-4 pt-1">
                  <h3 className="text-2xl font-sans font-bold text-foreground mb-3 tracking-tight">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground text-lg leading-relaxed font-sans">
                    {step.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}